import { gql } from '@apollo/client'

const EVENT_FRAGMENT = gql`
  fragment EventFragment on Event {
    id
    entityType
    type
    sessionId
    subtype
    bulkOperationId
    entityId
    source
    original
    changes
    createdAt
    createdBy {
      id
      name
    }
  }
`

export default EVENT_FRAGMENT
